export const INIT_TOAST_MESSAGE = {
    hidden: true,
    message: "",
    variant: null
};